import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, GuardResult, MaybeAsync, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ServiceVersionService } from '../services/service-version.service';
import { ErrorPageReasons } from '../shared/constants';

const serviceVersionGuard = (
    serviceVersionService: ServiceVersionService,
    router: Router,
    redirect: string | undefined,
): MaybeAsync<GuardResult> => {
    return serviceVersionService.isServiceVersionSupported().pipe(
        map((isServiceVersionSupported) => {
            if (!isServiceVersionSupported) {
                return router.createUrlTree(['error'], { queryParams: { reason: ErrorPageReasons.ServiceVersion, redirect } });
            }

            return true;
        }),
        catchError(() => of(router.createUrlTree(['error'], { queryParams: { redirect } }))),
    );
};

export const serviceVersionCanMatchFn: CanMatchFn = () => {
    const router = inject(Router);
    const serviceVersionService = inject(ServiceVersionService);

    // https://github.com/angular/angular/issues/17359#issuecomment-584776004
    const redirect = router.getCurrentNavigation()?.extractedUrl.toString();

    return serviceVersionGuard(serviceVersionService, router, redirect);
};

export const serviceVersionCanActivateFn: CanActivateFn = (_, state) => {
    const router = inject(Router);
    const serviceVersionService = inject(ServiceVersionService);

    const redirect = state.url;

    return serviceVersionGuard(serviceVersionService, router, redirect);
};
